<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.services')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="settings-top-bar sticky-header" ref="optionsTopBar">
      <div class="text-right">
        <p class="d-inline-flex">
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.saveChanges')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <form v-if="settings && settings[0]" class="services"> 
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12"><h5>Firebase</h5></div>
            <template v-if="settings[0].firebase_api_key != ''">
              <div class="col-md-12">
                <div class="form-group">
                  <label>firebase_api_key</label>
                  <input type="text" name="firebase_api_key" placeholder="firebase_api_key" v-model="settings[0].firebase_api_key" class="form-control">
                </div>
              </div>
            </template>
            <template v-else>
              <div class="col-md-12">
                <div class="form-group">
                  <label>Firebase Project Id</label>
                  <input type="text" name="project_id" placeholder="Project ID" v-model="settings[0].firebase.project_id" class="form-control">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>Firebase Json Key</label>
                  <textarea type="text" name="json_key" placeholder="Json Key" v-model="settings[0].firebase.json_key" class="form-control" style="height: 150px;"></textarea>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="row" v-if="settings[0].apple">
            <div class="col-md-12"><h5>Apple</h5></div>
            <div class="col-md-6">
              <div class="form-group">
                <label>client_id</label>
                <input type="text" name="client_id" placeholder="client_id" v-model="settings[0].apple.client_id" class="form-control">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>redirect</label>
                <input type="text" name="client_id" placeholder="redirect" v-model="settings[0].apple.redirect" class="form-control">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>key_id</label>
                <input type="text" name="client_id" placeholder="key_id" v-model="settings[0].apple.key_id" class="form-control">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>team_id</label>
                <input type="text" name="client_id" placeholder="team_id" v-model="settings[0].apple.team_id" class="form-control">
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>key</label>
                <textarea type="text" name="client_id" placeholder="team_id" v-model="settings[0].apple.key" class="form-control" style="height: 150px;"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="row" v-if="settings[0].facebook">
            <div class="col-md-12"><h5>Facebook</h5></div>
            <div class="col-md-6">
              <div class="form-group">
                <label>client_id</label>
                <input type="text" name="client_id" placeholder="client_id" v-model="settings[0].facebook.client_id" class="form-control">
                <span>1048664826452257</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>client_secret</label>
                <input type="text" name="client_secret" placeholder="client_secret" v-model="settings[0].facebook.client_secret" class="form-control">
                <span>f375ea240e987043e0464fc5677cb830</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>redirect</label>
                <input type="text" name="redirect" placeholder="redirect" v-model="settings[0].facebook.redirect" class="form-control">
                <span>https://gateway.taptasty.com/handler/facebook/</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="row" v-if="settings[0].google">
            <div class="col-md-12"><h5>Google</h5></div>
            <div class="col-md-6">
              <div class="form-group">
                <label>client_id</label>
                <input type="text" name="client_id" placeholder="client_id" v-model="settings[0].google.client_id" class="form-control">
                <span>679589114914-stdcelgg7vr4it1qf0vnv9e17vep151u.apps.googleusercontent.com</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>client_secret</label>
                <input type="text" name="client_secret" placeholder="client_secret" v-model="settings[0].google.client_secret" class="form-control">
                <span>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</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>redirect</label>
                <input type="text" name="redirect" placeholder="redirect" v-model="settings[0].google.redirect" class="form-control">
                <span>https://gateway.taptasty.com/handler/google</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Button, Select} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  // import {mapFields} from 'vee-validate'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import vSelect from 'vue-select'
  Vue.component('v-select', vSelect)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      // GeneralTopBar,
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select,
      PSwitch
    },
    data () {
      return {
        settings: null
      }
    },
    created () {
      this.getData()
    },
    methods: {
      getData () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/services', 'GET', data, (response) => {
          if (response.status === true) {
            this.settings = response.data.settings

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop][0])
          }
        }
      },
      saveDetails () {
        var companyID = this.$session.get('selectedCompany')
        this.settings[0].apple.key = this.settings[0].apple.key.replace(/(\r\n|\n|\r)/gm, '')
        var data = {
          'token': this.$session.get('token'),
          'settings': this.settings
        }
        this.apiRequest('/services/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            swal({'text': 'Saved', 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            swal({'text': 'Error', 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            // swal({'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/Services.vue